export default "__VITE_ASSET__d56fbdbb__"